module.exports = __webpack_public_path__ + "img/case7.91d78606.png";